import { SERVER_URL } from '../../config';
import { createHttpClient } from './httpClient';

export const httpClient = createHttpClient(SERVER_URL);
